/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

// Stream polyfill for xml-js library (required for Node.js stream API in browser)
import * as streamBrowserify from 'stream-browserify';
(globalThis as any).stream = streamBrowserify;
(globalThis as any).Stream = streamBrowserify.Stream;

// Process polyfill for Node.js compatibility
if (!(globalThis as any).process) {
  (globalThis as any).process = {
    env: {},
    nextTick: (fn: Function, ...args: any[]) => setTimeout(() => fn(...args), 0),
    version: 'v16.0.0',
    versions: {},
    cwd: () => '/',
  };
}

(window as any).global = window;
